import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-xl border border-input bg-white px-3.5 py-2.5 text-base shadow-[0_1px_2px_rgba(16,24,40,.04)] transition-all placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-[#1E9E2A] focus-visible:ring-[3px] focus-visible:ring-[#1E9E2A]/15 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
